export default __webpack_public_path__ + "static/media/285.3c7f6426.gif";